jQuery(document).ready(commonInit);

function commonInit(){
	
	//don't load anything on init after this in admin editor
	if(jQuery('#wpwrap').length !== 0) return false;
	
	setupMobileMenu();
	setupColumns();
	setupSearch();
	setupResourceBar();
	setupBlogFilters();
}

function setupMobileMenu(){
	
	jQuery("#mobile-nav").mmenu({

	}, {

		classNames: {
			selected: "current-menu-item",
			fixedElements: {
				
				fixed: "mobile-sticky"
				
			}
			
		}
		
	});
	
}

function setupColumns(){
	
	jQuery('.wp-block-columns').each(function(){
		
		var current = jQuery(this);
		var columnCount = jQuery('> *', current).length;
		
		current.addClass('has-'+columnCount+'-columns');
		if(current.hasClass('cards')){
			current.append('<span class="rectangleTriangle"></span><span class="rectangleTriangleRight"></span>')
		}
		
	});
	
}

function setupSearch(){
	
	jQuery('#search-toggle').on('click', function(e){
		e.stopPropagation();
		jQuery('html').toggleClass('show-search');
		jQuery('#s').focus();
	});
	
	jQuery('.search').on('click', function(e){
		e.stopPropagation();
	});
	
	jQuery('html').on('click', function(){
		jQuery('html').removeClass('show-search');
	});
	
}

function setupResourceBar(){
	
	jQuery('#resources-toggle').on('click', function(){
		jQuery('#resource-bar').slideToggle(300);
	});
	
	jQuery('.resources.slick').slick({
		slidesToShow: 4,
		slidesToScroll: 4,
		rows: 1,
		slidesPerRow: 1,
		dots: false,
		arrows: true,
		autoplay: false,
		autoplaySpeed: 3000,
		fade: false,
		easing: "linear",
		pauseOnHover: false,
		infinite: true,
		draggable: false,
		swipe: true,
		adaptiveHeight: false,
		responsive: [
	    {
	      breakpoint: 1100,
	      settings: {
	      	slidesToShow: 2,
			slidesToScroll: 2,
	      }
	    },
	    {
	      breakpoint: 550,
	      settings: {
	      	slidesToShow: 1,
			slidesToScroll: 1,
	      }
	    }
	  ]
	});
	
	setTimeout(function(){
		jQuery('#resource-bar').hide();
		jQuery('#resource-bar').addClass('show');
	}, 200);
	
}

function setupBlogFilters() {
	
	jQuery("#blog-categories").on("change", function(){
		
		const url = jQuery(this).val();
		
		console.log(url);	
	
		if(url) {
			window.location = url;
		}
		
	});
	
}